import { View } from 'ol';
import { GeoJSON } from 'ol/format';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';

export let restoredLocation = false;

export const rememberLocation = (view) => {
  sessionStorage.setItem('location', JSON.stringify({
    centre: view.getCenter(),
    zoom: view.getZoom()
  }));
};

export const restoreLocation = () => {
  const restorable = sessionStorage.getItem('location');
  const l = JSON.parse(restorable);
  if (l) restoredLocation = true;
  return new View({ center: l?.centre ?? [0, 0], zoom: l?.zoom ?? 0 });
};

let db;

const geojsonToFeatures = (geojson) => new GeoJSON().readFeatures(geojson, {
  // dataProjection: 'EPSG:4326',
  featureProjection: 'EPSG:25833'
});
const idbToOl = (l) => new VectorLayer({
  properties: l.properties,
  source: new VectorSource({ features: geojsonToFeatures(l.geojson) })
});

// indexedDB.databases().then(r => r.forEach(db => console.log(db)));
// indexedDB.deleteDatabase('kgk');

class IDBGeoJSON {
  constructor(db_name) {
    // this.create(db_name);
    this.db_name = db_name;
  }

  create = (db_name) => new Promise((resolve, reject) => {
    const dbOpenRequest = indexedDB.open(db_name);
    dbOpenRequest.onerror = (event) => {
      reject(`Klarte ikke å åpne database: ${event.target.errorCode}`);
    };
    dbOpenRequest.onupgradeneeded = (event) => {
      // console.log('Database fantes ikke eller ny versjon lagt ut');
      db = event.target.result;
      db.onerror = (e) => console.log('Database lastes ikke opp');
      db.createObjectStore('layers', { keyPath: 'id' });
      // console.log('Object store created');
      // resolve(db); // too early, onsuccess will be triggered anyways
    };
    dbOpenRequest.onsuccess = (sender) => {
      // console.log('Databasen ble åpnet');
      db = dbOpenRequest.result;
      resolve(db);
    };
  });

  open = () => db ? Promise.resolve(db) : this.create(this.db_name);

  updateLayer(layer) {
    const p = layer.getProperties();
    const id = p.id;
    const label = p.label;
    const type = p.type;
    const geojson = new GeoJSON().writeFeaturesObject(
      layer.getSource().getFeatures(), {
        // dataProjection: 'EPSG:4326',
        featureProjection: 'EPSG:25833',
        rightHanded: true,
        // decimals: 1
      }
    );
    const store = db.transaction('layers', 'readwrite').objectStore('layers');
    store.put({ id, properties: { id, label, type }, geojson });
  }

  deleteLayer(id) {
    db.transaction('layers', 'readwrite').objectStore('layers').delete(id);
  }

  getLayer = (id) => this.open().then(db => new Promise((resolve, reject) => {
    // console.log('All stores:', db.objectStoreNames);
    const s = 'layers';
    if (db.objectStoreNames.contains(s))
      db.transaction(s).objectStore(s).get(id).onsuccess = e => {
        const savedDrawings = e.target.result;
        if (savedDrawings) resolve(idbToOl(savedDrawings));
        else console.log('Ingen forrige tegning funnet');
      };
  })).catch(e => console.log('Kunne ikke åpne idb', e));

  getLayers = () => new Promise((resolve, reject) => {
    db.transaction('layers').objectStore('layers').getAll().onsuccess = (e) =>
      resolve(e.target.result.map(l => idbToOl(l)));
    // const objectStore = db.transaction('layers').objectStore('layers');
    // objectStore.openCursor().onsuccess = (event) => {
    //   const cursor = event.target.result;
    //   if (cursor) {
    //     console.log(cursor.key, cursor.value);
    //     cursor.continue();
    //   } else console.log('No more entries!');
    // };
  });
} // end Class

export const idb = new IDBGeoJSON('kgk');
// idb.addLayer({ id: 2, outside: true });
// idb.getLayers().then(a => a.forEach(l => console.log(l.getProperties())));
// idb.deleteLayer('drawings');
// idb.getLayer('drawings').then(d => console.log(d.getProperties()));
